(function () {
  function mountBannerTwoContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(2)');
    if (!slide || slide.querySelector('.an-hero-copy-layer--summer')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--summer';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--summer';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--summer">',
      '<h2>Discover Your Summer Essential</h2>',
      '<p>Not sure what to choose? Get personalized fragrance recommendations curated around your taste.</p>',
      '<a class="an-hero-cta an-hero-cta--summer" href="/pages/scent-profiling">Start Scent Profiling</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerTwoContent);
  } else {
    mountBannerTwoContent();
  }

  document.addEventListener('shopify:section:load', mountBannerTwoContent);
})();
